import React from 'react';
import { Search } from 'lucide-react';
import FilterPopover from './FilterPopover';

/** Shared list-search control used by modules with FilterPopover-based filters. */
const StandardSearchFilter = ({
  t,
  value,
  onChange,
  placeholder,
  open,
  active,
  onToggle,
  onReset,
  onCancel,
  onApply,
  isArabic = false,
  panelWidthClass = 'w-[300px]',
  className = 'w-full sm:w-[220px]',
  label,
  children,
}) => (
  <FilterPopover
    label={label || t('lbl_search', 'Arama')}
    open={open}
    active={active}
    onToggle={onToggle}
    onReset={onReset}
    onCancel={onCancel}
    onApply={onApply}
    align={isArabic ? 'left' : 'right'}
    panelWidthClass={panelWidthClass}
    className={className}
  >
    <div className="relative">
      <Search size={14} className={`absolute top-1/2 -translate-y-1/2 text-slate-400 ${isArabic ? 'right-3' : 'left-3'}`} />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={`w-full bg-slate-50 border border-slate-200 rounded-xl py-2.5 text-[12px] font-bold text-slate-700 outline-none focus:border-indigo-500 ${isArabic ? 'pr-9 pl-3 text-right' : 'pl-9 pr-3 text-left'}`}
      />
      {children}
    </div>
  </FilterPopover>
);

export default StandardSearchFilter;
